<template>
  <div class="page-container content fy">
    <van-nav-bar
      class="nav-bg"
      left-arrow
      fixed
      title=""
      @click-left="show = !show"
      :z-index="10"></van-nav-bar>
    <div style="height: 20px"></div>
    <!-- 测试题 -->
    <van-swipe
      ref="swipe"
      :touchable="false"
      class="my-swipe"
      :show-indicators="false"
      :loop="false"
      indicator-color="white"
      @change="onSwipeChange">
      <van-swipe-item v-for="(q, qi) of questions" :key="`swipe-item-${qi}`">
        <div class="test">
          <div class="title">
            <span class="sp4">{{ q.title }}</span>
          </div>
          <van-cell-group class="answer-list">
            <van-cell
              v-for="(a, ai) in q.options"
              :key="`answer-${qi}-${ai}`"
              @click="nextQuestion(q, a, qi, $event)"
              :class="{ active: answers[q.id] && answers[q.id].id == a.id }">
              <div class="pick" :name="a.item">{{ a.item }}</div>
            </van-cell>
          </van-cell-group>
        </div>
        <div style="margin: 20px 40px; color: white">
          温馨提示：本次问答共{{ questions.length }}题，答对<span
            style="color: rgb(56, 7, 56)"
            >0-1题</span
          >获得<span style="color: rgb(56, 7, 56)">0次</span>抽奖，答对<span
            style="color: rgb(56, 7, 56)"
            >2-3题</span
          >获得<span style="color: rgb(56, 7, 56)">1次</span>抽奖，答对<span
            style="color: rgb(56, 7, 56)"
            >4-5题</span
          >获得<span style="color: rgb(56, 7, 56)">2次</span>抽奖，答对<span
            style="color: rgb(56, 7, 56)"
            >{{ questions.length }}题</span
          >获得<span style="color: rgb(56, 7, 56)">3次</span>抽奖。
        </div>
        <div class="control">
          <template v-if="qi > 0">
            <div class="start" @click="prevQuestion">上一题</div>
          </template>
          <template v-if="qi === questions.length - 1">
            <van-button
              :disabled="Object.keys(answers).length < questions.length"
              class="start"
              size="large"
              @click="submit"
              v-preventReClick
              >提交</van-button
            >
          </template>
        </div>
      </van-swipe-item>
    </van-swipe>

    <!-- Popup -->
    <van-popup
      v-model="show"
      :lock-scroll="false"
      :close-on-click-overlay="false"
      :close-on-popstate="true">
      <div class="popup-content">
        <div class="title">
          <div class="d1">还差一点就完成了，真的要现在退出吗？</div>
          <div class="d2">完成答题才可以获得抽盲盒机会哦~</div>
        </div>
        <div class="select">
          <span
            class="sp1"
            @click="
              show = false
              goableBack()
            "
            >暂时放弃</span
          >
          <span class="sp2" @click="show = !show">继续答题</span>
        </div>
      </div>
    </van-popup>
    <answer-pop-vue
      :show.sync="showSuccess"
      :showPopParams="showPopParams"
      @close="showSuccess = false"
      @commitUse="clickUse"></answer-pop-vue>
  </div>
</template>
<script>
import {
  Toast,
  Cell,
  CellGroup,
  Button,
  Radio,
  RadioGroup,
  Swipe,
  SwipeItem,
  Popup,
  Dialog
} from "vant"
import answerPopVue from "./components/answerPop.vue"
import {
  midautumnLoad,
  subjectAnswer,
  subjectQuestion
} from "../../api/lottery"
import { mapGetters } from "vuex"
import session from "../../utils/session"
export default {
  components: {
    [Toast.name]: Toast,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Radio.name]: Radio,
    [RadioGroup.name]: RadioGroup,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Popup.name]: Popup,
    answerPopVue,
    [Dialog.Component.name]: Dialog.Component
  },
  data() {
    return {
      curIndex: 0,
      show: false, // popup
      questions: [],
      answers: {}, // 各题分数集合,
      running: false,

      activityld: "",
      showPopParams: {},
      showSuccess: false
    }
  },

  computed: {
    ...mapGetters(["channel", "userInfo"])
  },
  mounted() {
    if (this.channel.toLowerCase() != "ta") {
      this.$router.push({ name: "home" })
      return
    }
    setTimeout(() => {
      if (!this.userInfo.isAuthName) {
        this._showTipsInfo(
          "温馨提示",
          "您当前暂未实名，进行实名认证后即可参与活动哦",
          "去首页",
          "去实名",
          () => {
            session.setJson("cq", { target: "answerdraw" })
            this.$router.push({ name: "realname" })
          },
          () => {
            this.$router.push({ name: "home" })
          }
        )
      }
    }, 500)
    midautumnLoad()
      .then((data) => {
        if (data) {
          this.activityId = data.info.id
          this.loadQuestions()
        }
      })
      .catch((e) => {
        this.$toast(e.msg || e.message)
      })
  },
  methods: {
    loadQuestions() {
      subjectQuestion({ activityId: this.activityId })
        .then((data) => {
          this.initData(data)
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },
    // popup
    showPopup() {
      this.show = true
    },
    initData(data) {
      this.questions = data
    },
    showError(e) {},

    /**
     * 选择答案, 且跳转到下一题
     */
    nextQuestion(q, a, qi) {
      console.log("q == %O, a == %O, qi == %O", q, a, qi)
      if (this.running) {
        return
      }
      if (qi < this.questions.length - 1) {
        this.running = true
      }
      this.$set(this.answers, q.id, a)

      if (this.curIndex != qi) {
        return
      }
      setTimeout(() => {
        this.$refs.swipe.next()
      }, 300)
    },
    onSwipeChange(index) {
      this.curIndex = index
      setTimeout(() => {
        this.running = false
      }, 500)
    },
    prevQuestion() {
      this.$refs.swipe.prev()
    },

    submit() {
      // let score = Object.values(this.answers).reduce((total, num) => {
      //   return (total.score || total) + num.score
      // })
      const results = []
      for (const [key, item] of Object.entries(this.answers)) {
        results.push({ subId: key, optionsId: item.id })
      }

      const form = {
        activityId: this.activityId,
        answers: JSON.stringify(results)
      }
      subjectAnswer(form)
        .then((data) => {
          this.showPopParams = data
          this.showSuccess = true
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },
    clickUse() {
      this.$router.push({ name: "blindbox" })
    }
  }
}
</script>
<style lang="less" scoped>
// van-nav-bar - title
::v-deep .van-nav-bar__title {
  font-size: 15px;
  color: #333;
}
// icon
::v-deep .van-icon-arrow-left::before {
  color: #333;
}
.nav-bg {
  background-color: transparent;
  &::after {
    display: none;
  }
}

// 整体
.content {
  min-height: calc(100vh - 46px);
  background: url("../../assets/img/lottery/mid/mid_answer_bg.jpg") no-repeat;
  background-size: 100% 100%;

  // 测试题
  .test {
    margin: 0 30px;
    padding: 15px 15px;
    background: url("../../assets/img/lottery/mid/mid_answer_box.jpg") no-repeat;
    background-size: 100% 100%;
    .title {
      margin: 15px 15px 5px 15px;
      color: rgb(185, 26, 31);
      .sp1 {
        font-size: 25px;
      }
      .sp2 {
        margin: 0 3px;
      }
      .sp3 {
        font-size: 16px;
      }
      .sp4 {
        font-weight: 700;
        letter-spacing: 0.5px;
      }
    }
    .answer-list {
      margin-bottom: 15px;
      ::v-deep .van-cell {
        display: flex;
        flex-wrap: wrap;
        background-color: transparent;

        .pick {
          color: rgb(185, 26, 31);
          font-size: 15px;
        }
      }
      ::v-deep .van-cell:not(:last-child)::after {
        border-bottom: 0;
      }
      .active {
        border-radius: 5px;
        background-color: rgb(185, 26, 31);
        // 选中后去掉下边框 白线
        &.van-cell::after {
          border: none;
        }
        .pick {
          color: #fff;
        }
      }
    }
    ::v-deep .van-hairline--top-bottom::after {
      border-width: 0;
    }
    ::v-deep .van-cell-group {
      background-color: transparent;
    }
  }

  // control
  .control {
    margin: 15px;
    .start {
      color: rgb(255, 255, 255);
      font-size: 15px;
      text-align: center;
      margin-top: 20px;
    }
    .van-button {
      color: #fff;
      border-radius: 5px;
      margin-left: 20px;
      width: calc(100% - 40px);
      background-color: rgb(185, 26, 31);
    }
  }

  .van-popup {
    border-radius: 5px;
    overflow-y: visible;
    .popup-content {
      width: 275px;
      height: 160px;
      position: relative;
      .title {
        width: 230px;
        margin: auto;
        .d1 {
          margin-top: 30px;
          font-size: 15px;
        }
        .d2 {
          font-size: 14px;
          margin-top: 8px;
          color: #666;
        }
      }

      .select {
        display: flex;
        height: 40px;
        position: absolute;
        bottom: 0;
        left: 0;

        span {
          line-height: 40px;
          text-align: center;
        }
        .sp1 {
          width: 137px;
          color: #666;
          background-color: #dcdcdc;
          border-radius: 0 0 0 5px;
        }
        .sp2 {
          width: 138px;
          color: #fff;
          background-color: rgb(185, 26, 31);
          border-radius: 0 0 5px 0;
        }
      }
    }
  }
}
</style>